import { Injectable } from "@nestjs/common";
import { LocationAuditDto } from "./dto/location-audit.dto";
import { LocationAudit } from "./entity/location-audit.entity";

@Injectable()
export class LocationAuditAdapter {
   public convertDtoToLocationAuditEntity(auditDto : LocationAuditDto, isUpdate : boolean  = false ) : LocationAudit {
          const locationAudit = new LocationAudit();
          
          locationAudit.auditId = auditDto.auditId;
          locationAudit.locationId = auditDto.locationId;
          locationAudit.auditType = auditDto.auditType;
          locationAudit.auditDate = auditDto.auditDate;
          locationAudit.startDate = auditDto.startDate;
          locationAudit.completedDate = auditDto.completedDate;
          locationAudit.auditProvider = auditDto.auditProvider;
          locationAudit.auditName = auditDto.auditName;
          locationAudit.auditOwner = auditDto.auditOwner;
          locationAudit.phoneNumber = auditDto.phoneNumber;
          locationAudit.working = auditDto.working;
          locationAudit.Notworking = auditDto.Notworking;
          locationAudit.status = auditDto.status;
          locationAudit.remarks = auditDto.remarks;
          locationAudit.reason = auditDto.reason;
          locationAudit.isActive = auditDto.isActive == undefined ? true : auditDto.isActive;
          locationAudit.assetsCount = auditDto.assetsCount;

          return locationAudit;

   }

   public convertEntityToAuditDto(audit: LocationAudit) : LocationAuditDto {
         const locationAuditDto = new LocationAuditDto()
         
         locationAuditDto.auditId = audit.auditId;
          locationAuditDto.locationId = audit.locationId;
          locationAuditDto.auditType = audit.auditType;
          locationAuditDto.auditDate = audit.auditDate;
          locationAuditDto.startDate = audit.startDate;
          locationAuditDto.completedDate = audit.completedDate;
          locationAuditDto.auditProvider = audit.auditProvider;
          locationAuditDto.auditName = audit.auditName;
          locationAuditDto.auditOwner = audit.auditOwner;
          locationAuditDto.phoneNumber = audit.phoneNumber;
          locationAuditDto.working = audit.working;
          locationAuditDto.Notworking = audit.Notworking;
          locationAuditDto.status = audit.status;
          locationAuditDto.remarks = audit.remarks;
          locationAuditDto.reason = audit.reason;
          locationAuditDto.isActive = audit.isActive;
          locationAuditDto.createdAt = audit.createdAt;
          locationAuditDto.createdUser = audit.createdUser;
          locationAuditDto.updatedAt = audit.updatedAt;
          locationAuditDto.updatedUser = audit.updatedUser;
          locationAuditDto.versionFlag = audit.versionFlag;
          locationAuditDto.assetsCount = audit.assetsCount;

          return locationAuditDto;

   }
}